// extracted by mini-css-extract-plugin
export var addViewLink = "_12-1";
export var availabilityIcon = "_12-16";
export var availabilitySelectionIcon = "_12-15";
export var backButton = "_12-2";
export var backIcon = "_12-z";
export var conversationCount = "_12-3";
export var dragHandle = "_12-5";
export var dropdown = "_12-e";
export var dropdownIcon = "_12-7";
export var dropdownOption = "_12-6";
export var dropdownTriangle = "_12-d";
export var expand = "_12-f";
export var folder = "_12-i";
export var folderItem = "_12-c";
export var icon = "_12-8";
export var iconRow = "_12-9";
export var image = "_12-a";
export var logo = "_12-b";
export var navContainer = "_12-h";
export var navigationFooter = "_12-g";
export var pageShell = "_12-0";
export var placeholderAvailable = "_12-11";
export var placeholderBox = "_12-14";
export var placeholderBusy = "_12-13";
export var placeholderUnavailable = "_12-12";
export var profile = "_12-k";
export var profileContainer = "_12-m";
export var profileDropdown = "_12-n";
export var profileImage = "_12-l";
export var profileMain = "_12-o";
export var profileSubtitle = "_12-q";
export var profileTitle = "_12-p";
export var reorderIcon = "_12-r";
export var sentLine = "_12-u";
export var settingsHeader = "_12-s";
export var sidenavTextColor = "_12-y";
export var spamLine = "_12-t";
export var subitemWithTag = "_12-4";
export var supportItems = "_12-j";
export var teamText = "_12-10";
export var viewLine = "_12-x";
export var viewLineButton = "_12-w";
export var viewLineButtons = "_12-v";